import { useSelector } from "react-redux";
import { utilsState } from "../../../sotre/redux/features/utilsSlice";
import { useRef, useState } from "react";
import { successMessage } from "../../../utils/toastify-message/ToastifyMessage";
import { PiXFill } from "react-icons/pi";
import UserModal from "../../../components/common/modals/user-modal/UserModal";

import Button from "../../../components/common/button/Button";
import Select from "../../../components/common/inputs/Select";
export default function UserMounthlySalesMounthlyReportsFilter({
  filterDataHandler,
  activeSearchButton,
}) {
  const { utils } = useSelector(utilsState);
  const userModalRef = useRef();
  const [user, setUser] = useState(null);
  const [filters, setFilters] = useState({});

  const handleUser = (data) => {
    setUser(data.name);
    setFilters((prev) => ({
      ...prev,
      userMobile: data.mobile,
      user: data._id,
    }));
    successMessage(`کاربر ${data?.name} انتخاب شد`);
  };

  const deleteUser = () => {
    setUser("");
    setFilters((prev) => ({ ...prev, user: "", userMobile: "" }));
  };

  const handleSearch = () => {
    filterDataHandler({ page: 1, ...filters });
  };

  return (
    <div className="w-full flex flex-col flex-wrap my-8 gap-6 px-6">
      <UserModal ref={userModalRef} handleUser={handleUser} />
      <div className="w-full flex flex-col sm:flex-row gap-6">
        <div className="w-full sm:w-1/4">
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            برند
          </label>
          <Select
            onChange={(e) =>
              setFilters((prev) => ({ ...prev, brand: e.target.value }))
            }
            id="brand"
            useFormik={false}
            className="bg-white text-center sm:text-right"
          >
            <option value={""} selected>
              همه
            </option>
            <option value={"saboora"}>صبورا</option>
            <option value={"attarbashi"}>عطارباشی</option>
          </Select>
        </div>
        <div className="w-full sm:w-1/4">
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            نقش
          </label>
          <Select
            onChange={(e) =>
              setFilters((prev) => ({ ...prev, role: e.target.value }))
            }
            id="province"
            useFormik={false}
            className="bg-white text-center sm:text-right"
          >
            <option value={""} selected>
              همه ی نقش ها
            </option>
            {utils
              ? utils.ROLES_VALUES.map((item) => {
                  return <option value={item.value}>{item?.name}</option>;
                })
              : null}
          </Select>
        </div>
        <div className="w-full sm:w-1/4 relative">
          <span
            onClick={() => userModalRef?.current?.showModal()}
            className="absolute w-full h-full z-10"
          ></span>
          {user ? (
            <PiXFill
              className=" cursor-pointer absolute left-2 bottom-3 text-red-500 z-20"
              onClick={deleteUser}
            />
          ) : null}
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            انتخاب کاربر
          </label>
          <input
            value={user}
            onChange={(e) => setUser(e.target.value)}
            disabled
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          />
        </div>
        <div className="w-full sm:w-auto flex items-end">
          <Button
            disabled={!activeSearchButton}
            onClick={handleSearch}
            text={activeSearchButton ? "جستجو" : "منتظر بمانید..."}
            color="primary"
            type="button"
            className="whitespace-nowrap w-full h-[42px]"
          />
        </div>
      </div>
    </div>
  );
}
